/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HtmlPageConfigInfoRespVo } from './HtmlPageConfigInfoRespVo';
import {
    HtmlPageConfigInfoRespVoFromJSON,
    HtmlPageConfigInfoRespVoFromJSONTyped,
    HtmlPageConfigInfoRespVoToJSON,
    HtmlPageConfigInfoRespVoToJSONTyped,
} from './HtmlPageConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseHtmlPageConfigInfoRespVo
 */
export interface ResponseHtmlPageConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseHtmlPageConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseHtmlPageConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {HtmlPageConfigInfoRespVo}
     * @memberof ResponseHtmlPageConfigInfoRespVo
     */
    data?: HtmlPageConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponseHtmlPageConfigInfoRespVo interface.
 */
export function instanceOfResponseHtmlPageConfigInfoRespVo(value: object): value is ResponseHtmlPageConfigInfoRespVo {
    return true;
}

export function ResponseHtmlPageConfigInfoRespVoFromJSON(json: any): ResponseHtmlPageConfigInfoRespVo {
    return ResponseHtmlPageConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponseHtmlPageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseHtmlPageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : HtmlPageConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseHtmlPageConfigInfoRespVoToJSON(json: any): ResponseHtmlPageConfigInfoRespVo {
    return ResponseHtmlPageConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponseHtmlPageConfigInfoRespVoToJSONTyped(value?: ResponseHtmlPageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': HtmlPageConfigInfoRespVoToJSON(value['data']),
    };
}

